// dep
import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import * as _ from 'lodash'
import jsPDF from "jspdf"
import "jspdf-autotable"
import { Router } from '@angular/router'

// app
import User from '../../constants/firestore/user'
import { Sort } from '../../constants/sort'
import { domainsWithData } from '../../constants/domains-with-data'
import { AuthService } from '../../services/auth.service'
import { DomainService } from '../../services/domain.service'
import { AdvancedPageable } from '../../constants/pageable'
import { SubscriptionService } from '../../services/subscription.service'
import { NONE_TYPE } from '@angular/compiler'

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls:  ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit {
  public user: User;
  public domain: string;
  public sort: Sort = {sortBy: 'created', direction: 'desc'};
  public previousPageable: { size: any; page: any };
  public pagination: any;
  public filterField: string;
  public domainValue;
  public loading = true;
  public firstLoading = true
  // public isAllSelected: boolean;
  public paginate: AdvancedPageable = { page: 1, size: 25,  totalPages: 1};
  public skipRecords = 0;
  public dataSource: any;
  public inputSearch: string = null
  public domainsOptions = [];
  public statusOptions = ["PAID", "UNPAID", "TRIAL", "BLOCKED"];
  public cols = [
    { header: 'Name & Emails', field: 'name'},
    { header: 'Status', field: 'status' },
    { header: 'Pricing', field: 'pricingVersion' },
    { header: 'Ultimate', field: 'ultimate'}, 
    { header: 'Basic', field: 'basic'},
    { header: 'Essential', field: 'essential'},    
    { header: 'Created On', field: 'created'},
    { header: 'Trial End', field: 'trialEnd'},
    { header: 'Next Billing Date', field: 'nextDue'},
    { header: 'Last Invoice', field: 'lastInvoicePaidDate'},
    { header: 'Domain', field: 'domain'},
    { header: 'Billing Override', field: 'billingOverride', hide: true},
  ];
  public readonly DOMAIN_COLS = [
    {header: 'Domain', field: 'domain'},
    {header: 'Essential', field: 'essential'},
    {header: 'Basic', field: 'basic'},
    {header: 'Ultimate', field: 'ultimate'}
  ];
  public domainDataSource = [];
  public statusFilter = "";
  public sortableColumns = ['name', 'status', 'pricingVersion', 'ultimate', 'basic', 'essential', 'nextDue', 'lastInvoicePaidDate', 'trialEnd', 'domain', 'created']
  
  private _searchTime: any;

  constructor(
    public auth: AuthService,
    public domainService: DomainService,
    private _cdr: ChangeDetectorRef,
    private _subscriptionService: SubscriptionService,
    private _router: Router
  ) {
    this.user = this.auth.session;
  }

  ngOnInit(): void {
    this.domainValue = "app.maplabs.com"
    this.domainService.getDomains().subscribe(
      res => {
      if (res.domains.length > 0) {
        this.domainsOptions =  domainsWithData(res.domains);
        this.getSubscription();
      }
    },
      err => this.loading = false
    );
  }

  /**
   * Sometimes we get a string that represents a date and sometimes we get an object with ['$date'] property
   * This is an unfortunate 'legacy' of the billing API not having consistent payload semantics.
   * This method is intended to cater to both 'types' of property and 'do the right thing' to nromalise the data
   * to a `Date` object. 
   * 
   * It seems that soemtimes we get a string that has full TZ info (and sometiems we DO NOT) - hence we 
   * will truncate the string to 'ignore' TZ info for admin frontend purposes (cleaner than fixing all endpoints)
   * 
   * @param input comes form payload of subsctiption endpoints onbilling API
   * @returns 
   */
  toDate (input: string | object): Date {
    let value = null

    if( typeof(input) === 'object' ) {
      value = input['$date']
    }
    else if (typeof(input) == 'string') {
      value = input
    }
    
    return value ? new Date(value.substring(0,19)) : null
  }

  getSubscription (waitMs=0): void {

    if (this._searchTime){
      clearTimeout(this._searchTime)
    }

    this._searchTime = setTimeout(()=> {
    this.loading = true;
    this._subscriptionService.getSubscriptionsPaginated(this.paginate,
                                                        this.sort,
                                                        this.domainValue, 
                                                        this.inputSearch, 
                                                        this.statusFilter)
        .subscribe(
      subscriptions => {
        this.dataSource = [];
        const data = subscriptions['items'];
        this.paginate.totalPages = subscriptions["totalPages"]
        data.forEach(el => {
            el.id = el._id.$oid;
            el.nextDue = this.toDate(el.nextDueDate);
            el.lastInvoicePaidDate = this.toDate(el.lastInvoicePaidDate?.$date);
            el.trial = el.trialEnd?.$date;
            el.trialEnd = this.toDate(el.trialEnd);
            el.created = this.toDate(el.createdAt);
            el.name = `${el.user.displayName} - ${el.user.email}`;
            this.dataSource.push(el);
        });
        this.getProducts();
        this.getSubscriptionByDomain();
        this.loading = false;
        this.firstLoading = false
      },
      err => {
        this.loading = false;
        this.firstLoading = false
    });
  }, waitMs)
    this._cdr.detectChanges();
  }

  getProducts() {
    let data = {};
    this.dataSource.forEach(el => {
      data = {};
      (el?.products || []).map(el => el.pid).filter((idx) => {
        data.hasOwnProperty(idx) ? data[idx] += 1 : data[idx] = 1;
      });
      Object.keys(data).forEach(d => el[d] = data[d])
    });
  }

  getSubscriptionByDomain() {
    let data = {};
    const domainsSet = [...new Set(this.dataSource.map(el => el.domain))];
    const domains = domainsSet.filter(domain => !!domain)

    domains.forEach((el) => {
      const items = this.dataSource.filter(i => i.domain == el);
      data = {};
      items.forEach(i => {
        i?.products?.map(i => i.pid).filter((indice) => {
          data.hasOwnProperty(indice) ? data[indice] += 1 : data[indice] = 1;
        });
      });

      this.domainDataSource.push({
        domain: el,
        data
      });
    });
  }

  // TODO: Unused, remove
  // getStatus() {
  //   const status = this.dataSource.map(el => el.status);
  //   const statusSet = [...new Set(status)];
  //   this.statusOptions = statusSet.filter(el => el != null && el != undefined);
  // }

  exportPdf(table) {
    const data = table.filteredValue || this.dataSource
    const exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
    const doc = new jsPDF('p','pt', [window.innerWidth, window.innerHeight]);
    doc['autoTable'](exportColumns, data);
    doc.save("subscription.pdf");
  }

  pageChange(event: any): void {
    this.skipRecords = event.first
    this.paginate.page = event.first/event.rows + 1
    this.paginate.size = event.rows
    this.getSubscription()
    
  }

  sortChange(event: any): void{
    this.sort = {
      sortBy: event.field,
      direction: event.order === -1 ? "desc": "asc"
    }
    this.getSubscription()
  }

  domainSearch(selectedDomain: string): void{
    this.domainValue = selectedDomain
    this.getSubscription()
  }

  inputFilterSeach(searchValue: string): void{
    this.inputSearch = searchValue
    this.paginate.page = 1
    this.getSubscription(1000)
  }

  initSort(): void {
    this.sort = {
      sortBy: 'created',
      direction: 'desc',
    };
  }

  selectSubscription(data) {
    this._router.navigate(
      [`admin/group/${data.user.uid}`],
      {state: {
          'tabIndex': 1,
          'gid': data.gid
        }
      }
    ).then();
  }

  getTotalTooltip(item) : string | null {
    return (item.lastInvoicePaidDate == null ? 'This subscription has no invoice' : null);
  }

  filterDomain(table, value, locTable) {
    table.filterGlobal(value, 'contains');
    locTable.filterGlobal(value, 'contains');
  }

  clearTable(table, locTable) {
    this.inputSearch = null;
    this.domainValue = null;
    table.clear();
    locTable.clear();
  }

  checkSortableColumn(colName: string): boolean{
    return this.sortableColumns.includes(colName)
  }

  filterTable(filterValue: string){
   this.statusFilter=filterValue
   this.getSubscription()
  }

}

